import type { AiExecutionPlan } from '../../types/aiOperational'
import { ExecutionAuthorityPill } from './ExecutionAuthorityPill'

export const OperationalPlanSummary = ({ plan }: { plan: AiExecutionPlan }) => (
  <div className="aiOperationalPlanSummary" aria-label="Operational plan summary">
    <div className="aiOperationalPlanSummaryHeader">
      <strong>{plan.title}</strong>
      <span>{plan.canAutoStart ? 'Local guidance can start' : 'Review or confirmation required'}</span>
    </div>
    <p>{plan.summary}</p>
    {plan.checkpoints.length ? (
      <p className="aiOperationalPlanSummaryCheckpoint">
        {plan.checkpoints.slice(0, 3).map((checkpoint) => checkpoint.title).join(' · ')}
      </p>
    ) : null}
    <ol className="aiOperationalPlanSummarySteps">
      {plan.steps.slice(0, 4).map((step) => (
        <li key={step.id}>
          <span>{step.title}</span>
          <ExecutionAuthorityPill authority={step.authority} />
        </li>
      ))}
    </ol>
  </div>
)
